import { render, staticRenderFns } from "./OssFileMgmt.vue?vue&type=template&id=66c761e4&scoped=true"
import script from "./OssFileMgmt.vue?vue&type=script&lang=js"
export * from "./OssFileMgmt.vue?vue&type=script&lang=js"
import style0 from "./OssFileMgmt.vue?vue&type=style&index=0&id=66c761e4&prod&lang=scss&scoped=true"
import style1 from "./OssFileMgmt.vue?vue&type=style&index=1&id=66c761e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c761e4",
  null
  
)

export default component.exports